// extracted by mini-css-extract-plugin
module.exports = {"input":"HomeSearchInput_input__FmG2n","inputSplitter":"HomeSearchInput_inputSplitter__3Bhh5"};